import React from 'react';
import Rockets from './rockets';

const Home = () => {
  <Rockets />;
};

export default Home;
